import PropTypes from "prop-types";
import React from "react";
import {
  CASHFREE_URL,
  WEBSITE_ASSETS_URL,
  WEBSITE_PDFS_URL,
} from "../../constants/Url";
import Conditional from "../../hocs/Conditional";
import { useDetectLanguage } from "../../hooks/useDetectLanguage";
import Image from "../Image";
import Link from "../Link";
import "./Footer.scss";
import { INTEGRATIONS, OTHERPRODUCTS, CERTIFICATES } from "./constants";

const Footer = ({ location }) => {
  const { languageCode } = useDetectLanguage(location);
  const show = languageCode === "en";
  const hideForGrowthPG =
    location?.pathname === "/growth/payment-gateway/" ||
    location?.pathname === "/growth/one-click-checkout/";

  return (
    <footer className="footer">
      <Conditional if={!hideForGrowthPG}>
        <section className="footer-main">
          <div className="container">
            <div className="row row-no-margin align-flex-start justify-space-between footer-main__row">
              <div>
                <h4>
                  <Image
                    src="https://cashfreelogo.cashfree.com/website/movefastlogo.png"
                    width="150"
                    height="48"
                    alt="cashfree"
                  />
                </h4>
                <p>
                  Cashfree Payments enables{" "}
                  <span className="bold">8,00,000+</span> growing businesses in
                  India and across the globe to collect payments, make payouts,
                  manage international payments, and more. Cashfree Payments is
                  backed by SBI, Y Combinator, Krafton, and Apis partners and
                  was incubated by PayPal.
                </p>
                <div className="footer-awards">
                  <a
                    href={`${WEBSITE_ASSETS_URL}/pdf/CashFree_PCI_DSS_COC_2024.pdf`}
                    target="_blank"
                    rel="noopener noreferrer">
                    <Image
                      src="https://cashfreelogo.cashfree.com/assets_images/marketing/pcidss.svg"
                      alt="PCI"
                      className="md:w-[48px] md:h-[48px] w-[44px] h-[44px]"
                      width="48"
                      height="48"
                    />
                  </a>
                  <a
                    href={`${WEBSITE_ASSETS_URL}/pdf/CASHFREEPAYMENTSINDIAPRIVATELIMITED-ISO 9001-2024.pdf`}
                    target="_blank"
                    rel="noopener noreferrer">
                    <Image
                      src="https://cashfreelogo.cashfree.com/assets_images/marketing/kvqa.svg"
                      alt="kvqa"
                      className="md:w-[48px] md:h-[48px] w-[44px] h-[44px]"
                      width="48"
                      height="48"
                    />
                  </a>
                  <a
                    href={`${WEBSITE_ASSETS_URL}/pdf/ISO27001_2022Year2024certificate.pdf`}
                    target="_blank"
                    rel="noopener noreferrer">
                    <Image
                      src="https://cashfreelogo.cashfree.com/assets_images/marketing/iso.svg"
                      alt="ISO"
                      className="md:w-[48px] md:h-[48px] w-[44px] h-[44px]"
                      width="48"
                      height="48"
                    />
                  </a>
                </div>
                <div className="flex mb-[64px] md:mb-[0px] flex-col mt-[28px] md:mt-[40px] bg-[#F6F6FE] px-[16px] py-[14px] gap-3">
                  {CERTIFICATES?.map(
                    ({ name, certificateLabel, certificateLink }) => (
                      <div key={name}>
                        <div className="font-extrabold text-[14px] text-[#6933D3]">
                          {name}
                        </div>
                        <Link
                          target="_blank"
                          className="text-[#240253]"
                          to={`${WEBSITE_PDFS_URL}/${certificateLink}.pdf`}>
                          <div className="underline italic font-bold text-[14px]">
                            {certificateLabel}
                          </div>
                        </Link>
                      </div>
                    ),
                  )}
                </div>
              </div>
              <div>
                <Conditional if={!!show}>
                  <h5>Collect Payments</h5>
                  <ul>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/payment-gateway-india/">Payment Gateway</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="https://flowwise.com/">flowWise</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/risk-shield-payment-gateway/">
                        RiskShield Payment Gateway
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/risk-shield-for-payment-disbursal/">
                        RiskShield Payouts
                      </Link>
                    </li>
                    {/* <li className="body-text text-[#240253] text-[14px] font-normal">
                    <Link to="/checkout-one/">Checkout One</Link>
                  </li> */}
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/payment-links/">Payment Links</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/buy-now-pay-later/">Buy Now Pay Later</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/payment-forms/">Payment Forms</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/easy-split/split-payment-gateway/">
                        Easy Split
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/bbps-biller/">BBPS-Biller</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/soft-pos/">softPOS</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/upi-qr-code/">UPI QR Code</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="https://ecom360.club/">Ecom360</Link>
                    </li>
                  </ul>
                  <h5 className="ListMobileView-topMargin">
                    Recurring Payments
                  </h5>
                  <ul>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/recurring-payment/">Subscriptions</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/upi-autopay/">UPI AutoPay</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/enach/">eNACH</Link>
                    </li>
                  </ul>
                </Conditional>
                <h5 className="ListMobileView-topMargin">Make Payouts</h5>
                <ul>
                  <li className="body-text text-[#240253] text-[14px] font-normal">
                    <Link to="/payouts/">Payouts</Link>
                  </li>
                  <Conditional if={!!show}>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/vendor-payments/">Vendor Payments</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/cashgram/">Cashgram</Link>
                    </li>
                  </Conditional>
                  <li className="body-text text-[#240253] text-[14px] font-normal">
                    <Link to="/connected-banking/">Fund Sources</Link>
                  </li>
                </ul>
                <Conditional if={!!show}>
                  <h5 className="ListMobileView-topMargin">
                    Escrow as a service
                  </h5>
                  <ul>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/escrow-account/">One Escrow</Link>
                    </li>
                  </ul>
                  <h5 className="md:mt-[35px] mt-[25px]">
                    International Payments
                  </h5>
                  <ul>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      {" "}
                      <Link to="/accept-international-payments/">
                        Accept International Payments
                      </Link>{" "}
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      {" "}
                      <Link to="/international-payment-gateway/">
                        International Payment Gateway
                      </Link>{" "}
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      {" "}
                      <Link to="/international-payments/international-wire-transfer/">
                        Global Collections
                      </Link>{" "}
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      {" "}
                      <Link to="/send-money-to-india/global-payouts/">
                        Global Payouts
                      </Link>{" "}
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      {" "}
                      <Link to="/international-payments/outward-remittance/">
                        Send International Payments
                      </Link>{" "}
                    </li>
                  </ul>
                  <h5 className="md:hidden">Verify Identity</h5>
                  <ul className="md:hidden">
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/kyc-verification/">Secure ID</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/bank-account-verification/">
                        Bank Account Verification
                      </Link>
                    </li>
                    {/* <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/upi-id-from-phone-number/">
                        UPI ID from phone number
                      </Link>
                    </li> */}
                    {/* Hiding this PAN Verification due to RBI guidelines mentioned in ticketno : CUI-2826 */}
                    {/* <li className="body-text text-[#240253] text-[14px] font-normal">
                    <Link to="/PAN-verification/">PAN Verification</Link>
                  </li> */}
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/IFSC-verification-api/">
                        IFSC Verification
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/penny-drop-verification/">
                        Reverse Penny Drop Verification
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/aadhaar-verification/">
                        Aadhaar Verification
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/aadhaar-esign/">Aadhaar eSign</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/passport-verification-api/">
                        Passport Verification API{" "}
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/driving-license-verification-api/">
                        Driving License Verification API{" "}
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/digilocker-api/">DigiLocker API</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/gst-verification/">GST verification</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/kyc-link/">KYC Link</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/face-match-api/">Face Match API</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/geolocation-api/">Geolocation API</Link>
                    </li>
                  </ul>
                  <h5 className="md:hidden">Other Products</h5>
                  <ul className="md:hidden">
                    {OTHERPRODUCTS.map((data) => (
                      <li
                        className="body-text text-[#240253] text-[14px] font-normal"
                        key={data.name}>
                        <Link to={data.url}>{data.name}</Link>
                      </li>
                    ))}
                  </ul>
                </Conditional>
              </div>
              <Conditional if={!!show}>
                <div className="footerCustomWidth">
                  <h5 className="hideFooter">Verify Identity</h5>
                  <ul className="hideFooter">
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/kyc-verification/">Secure ID</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/bank-account-verification/">
                        Bank Account Verification
                      </Link>
                    </li>
                    {/* <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/upi-id-from-phone-number/">
                        UPI ID from phone number
                      </Link>
                    </li> */}
                    {/* <li className="body-text text-[#240253] text-[14px] font-normal">
                    <Link to="/PAN-verification/">PAN Verification</Link>
                  </li> */}
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/IFSC-verification-api/">
                        IFSC Verification
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/penny-drop-verification/">
                        Reverse Penny Drop Verification
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/aadhaar-verification/">
                        Aadhaar Verification
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/aadhaar-esign/">Aadhaar eSign</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/passport-verification-api/">
                        Passport Verification API{" "}
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/driving-license-verification-api/">
                        Driving License Verification API{" "}
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/digilocker-api/">DigiLocker API</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/gst-verification/">GST verification</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/kyc-link/">KYC Link</Link>
                    </li>

                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/face-match-api/">Face Match API</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/geolocation-api/">Geolocation API</Link>
                    </li>
                  </ul>
                  <h5 className="hideFooter !mt-[25px]">Other Products</h5>
                  <ul className="hideFooter">
                    {OTHERPRODUCTS.map((data) => (
                      <li
                        className="body-text text-[#240253] text-[14px] font-normal"
                        key={data.name}>
                        <Link to={data.url}>{data.name}</Link>
                      </li>
                    ))}
                  </ul>
                  <h5>Integrations</h5>
                  <ul>
                    {INTEGRATIONS.map((data) => (
                      <li
                        className="body-text text-[#240253] text-[14px] font-normal"
                        key={data.name}>
                        <Link to={data.url}>{data.name}</Link>
                      </li>
                    ))}
                  </ul>
                  <h5 className="ListMobileView-topMargin">Partner with us</h5>
                  <ul>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/affiliate-program/">Affiliate Program</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/embedded-payments/">Embedded Payments</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/partner-integration/">
                        Integrations & Offers
                      </Link>
                    </li>
                  </ul>
                  <h5 className="md:hidden !mt-[25px]">Developers</h5>
                  <ul className="md:hidden">
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <a href="https://docs.cashfree.com/">Documentation</a>
                    </li>
                  </ul>
                  <h5 className="md:hidden !mt-[25px]">Resources</h5>
                  <ul className="md:hidden">
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <a
                        href="https://www.cashfree.com/blog/"
                        target="_blank"
                        rel="noreferrer">
                        Blog
                      </a>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/case-study/">Customer Stories</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/events/">Events</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <a
                        href={`${CASHFREE_URL}/customer-reward-scheme-terms-and-conditions/`}
                        target="_blank"
                        rel="noreferrer">
                        Customer Reward Scheme
                      </a>
                    </li>
                  </ul>
                  <h5 className="md:hidden !mt-[25px]">Free Tools</h5>
                  <ul className="md:hidden">
                    {/* <li className="body-text text-[#240253] text-[14px] font-normal">
                    <Link to="/PAN-verification/">PAN Verification Tool</Link>
                  </li> */}
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/gst-verification/">GST Verification Tool</Link>
                    </li>
                  </ul>
                  <h5 className="md:hidden !mt-[25px]">Guides</h5>
                  <ul className="md:hidden">
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/how-to-choose-the-right-payment-stack-for-optimal-subscription-management/">
                        Recurring payment methods
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/api-banking-india/">API Banking</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="https://www.cashfree.com/resources/nach-mandate/">
                        NACH mandate
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/settlement-and-reconciliation-guide/">
                        Payment Gateway Settlements
                      </Link>
                    </li>
                  </ul>
                  <h5 className="md:hidden !mt-[25px]">Company</h5>
                  <ul className="md:hidden">
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      {" "}
                      <Link to="/about-us/">About us</Link>{" "}
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      {" "}
                      <Link to="/news-room/">Newsroom</Link>{" "}
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      {" "}
                      <Link to="/careers/">
                        Careers <span className="badge">Hiring</span>
                      </Link>{" "}
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      {" "}
                      <Link to="https://cashfreelogo.cashfree.com/website/pdf/Form_MGT_7-Cashfree-2022%20(1)%20(2).pdf">
                        Corporate Information
                      </Link>{" "}
                    </li>
                  </ul>
                  <h5 className="md:hidden !mt-[25px]">Help & Support</h5>
                  <ul className="md:hidden">
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/support/">Support</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/customer-resolution-guide/">
                        Cashfree Customer Resolution
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <a href="https://status.cashfree.com/">
                        Bank downtime detector
                      </a>
                    </li>
                  </ul>
                </div>
              </Conditional>
              <div className="hideFooter">
                <h5>Developers</h5>
                <ul>
                  <li className="body-text text-[#240253] text-[14px] font-normal">
                    <a href="https://docs.cashfree.com/">Documentation</a>
                  </li>
                </ul>
                <h5>Resources</h5>
                <ul>
                  <li className="body-text text-[#240253] text-[14px] font-normal">
                    <a
                      href="https://www.cashfree.com/blog/"
                      target="_blank"
                      rel="noreferrer">
                      Blog
                    </a>
                  </li>
                  <li className="body-text text-[#240253] text-[14px] font-normal">
                    <Link to="/case-study/">Customer Stories</Link>
                  </li>
                  <Conditional if={!!show}>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/events/">Events</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <a
                        href={`${CASHFREE_URL}/customer-reward-scheme-terms-and-conditions/`}
                        target="_blank"
                        rel="noreferrer">
                        Customer Reward Scheme
                      </a>
                    </li>
                  </Conditional>
                </ul>
                <Conditional if={!!show}>
                  <h5>Free Tools</h5>
                  <ul>
                    {/* <li className="body-text text-[#240253] text-[14px] font-normal">
                    <Link to="/PAN-verification/">PAN Verification Tool</Link>
                  </li> */}
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/gst-verification/">GST Verification Tool</Link>
                    </li>
                  </ul>
                  <h5>Guides</h5>
                  <ul>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/how-to-choose-the-right-payment-stack-for-optimal-subscription-management/">
                        Recurring payment methods
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/api-banking-india/">API Banking</Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="https://www.cashfree.com/resources/nach-mandate/">
                        NACH mandate
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/settlement-and-reconciliation-guide/">
                        Payment Gateway Settlements
                      </Link>
                    </li>
                  </ul>
                </Conditional>
                <h5>Company</h5>
                <ul>
                  <li className="body-text text-[#240253] text-[14px] font-normal">
                    {" "}
                    <Link to="/about-us/">About us</Link>{" "}
                  </li>
                  <li className="body-text text-[#240253] text-[14px] font-normal">
                    {" "}
                    <Link to="/news-room/">Newsroom</Link>{" "}
                  </li>
                  <Conditional if={!!show}>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      {" "}
                      <Link to="/careers/">
                        Careers <span className="badge">Hiring</span>
                      </Link>{" "}
                    </li>
                  </Conditional>
                  <li className="body-text text-[#240253] text-[14px] font-normal">
                    {" "}
                    <Link to="https://cashfreelogo.cashfree.com/website/pdf/Form_MGT_7-Cashfree-2022%20(1)%20(2).pdf">
                      Corporate Information
                    </Link>{" "}
                  </li>
                </ul>
                <h5>Help & Support</h5>
                <ul>
                  <li className="body-text text-[#240253] text-[14px] font-normal">
                    <Link to="/support/">Support</Link>
                  </li>
                  <Conditional if={!!show}>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <Link to="/customer-resolution-guide/">
                        Cashfree Customer Resolution
                      </Link>
                    </li>
                    <li className="body-text text-[#240253] text-[14px] font-normal">
                      <a href="https://status.cashfree.com/">
                        Bank downtime detector
                      </a>
                    </li>
                  </Conditional>
                </ul>
              </div>
            </div>
          </div>
        </section>
      </Conditional>

      <section className="footer-copyright">
        <div className="container">
          <div className="row row-no-margin justify-flex-start align-center footerMobileScreen">
            <div className="left hideMargin">
              <span className="font-medium text-[#240253]">
                &copy; {new Date().getFullYear()} Cashfree Payments India
                Private Limited
              </span>
            </div>

            <div className="legal font-normal">
              <Link className="font-normal text-[#240253]" to="/tnc/">
                Terms
              </Link>
              <Link className="font-normal text-[#240253]" to="/privacypolicy/">
                Privacy
              </Link>
              <Link className="hideOption" to="/grievance-redressal-policy/">
                Grievance Policy
              </Link>
            </div>
            <ul className="social">
              <li className="li-TagForLogo" id="li-TagForLogo">
                <a
                  href="https://www.facebook.com/gocashfree/"
                  target="_blank"
                  rel="noopener noreferrer">
                  <Image
                    src="https://cashfreelogo.cashfree.com/website/newNavImg/001-facebook.svg"
                    alt="facebook"
                    width="25"
                    height="25"
                  />
                </a>
              </li>
              <li className="li-TagForLogo" id="li-TagForLogo">
                <a
                  href="https://www.instagram.com/cashfree.payments/"
                  target="_blank"
                  rel="noopener noreferrer">
                  <Image
                    src="https://cashfreelogo.cashfree.com/website/newNavImg/011-instagram.svg"
                    alt="instagram"
                    width="25"
                    height="25"
                  />
                </a>
              </li>
              <li className="li-TagForLogo" id="li-TagForLogo">
                <a
                  href="https://twitter.com/gocashfree"
                  target="_blank"
                  rel="noopener noreferrer">
                  <Image
                    src="https://cashfreelogo.cashfree.com/website/newNavImg/013-twitter-1%201.svg"
                    alt="twitter"
                    width="25"
                    height="25"
                  />
                </a>
              </li>
              <li className="li-TagForLogo" id="li-TagForLogo">
                <a
                  href="https://www.linkedin.com/company/cashfree/"
                  target="_blank"
                  rel="noopener noreferrer">
                  <Image
                    src="https://cashfreelogo.cashfree.com/website/newNavImg/010-linkedin.svg"
                    alt="linkedin"
                    width="25"
                    height="25"
                  />
                </a>
              </li>
              <li className="li-TagForLogo" id="li-TagForLogo">
                <a
                  href="https://www.youtube.com/channel/UCX06yVYIREbM4lMRwVi_6Aw"
                  target="_blank"
                  rel="noopener noreferrer">
                  <Image
                    src="https://cashfreelogo.cashfree.com/website/NavFooter/008-youtube.svg"
                    alt="youtube"
                    width="25"
                    height="25"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </footer>
  );
};

Footer.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string }),
};

Footer.defaultProps = {
  location: null,
};

export default Footer;
